import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import AdminPage from "../../../components/admin/AdminPage";
import AboutOrganization from "./AboutOrganization";
import FAQ from "./FAQ";
import Query from "./Query";
import PaymentHistory from "./PaymentHistory";
import { usePermissions } from "../../../context/PermissionsContext";

const settingsTabs = [
  { id: 'about-organization', label: 'About Organization', icon: 'fluent:building-24-regular', permission: 'settings_about_organization_view' },
  { id: 'faq', label: 'FAQ', icon: 'fluent:question-circle-24-regular', permission: 'settings_faq_view' },
  { id: 'query', label: 'Support Query', icon: 'fluent:chat-help-24-regular', permission: 'settings_query_view' },
  // Payment History temporarily hidden
  // { id: 'payment-history', label: 'Payment History', icon: 'fluent:payment-24-regular', permission: 'settings_payments_view' },
];

function Settings() {
  const { permissions } = usePermissions();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("about-organization");

  useEffect(() => {
    const tabFromUrl = searchParams.get("activeTab");
    if (tabFromUrl) setActiveTab(tabFromUrl);
  }, [searchParams]);

  const handleTabChange = (tab) => {
    const t = settingsTabs.find((x) => x.id === tab);
    if (t && !permissions[t.permission]) {
      toast.warning(`You don't have permission to view ${t.label.toLowerCase()}`);
      return;
    }
    setActiveTab(tab);
  };

  return (
    <AdminPage
      title="Settings"
      description="Organization details, FAQ, support queries, and payment history."
    >
      <div className="rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden">
        <div className="flex flex-wrap border-b border-gray-100 bg-gray-50/50 px-2 pt-2 gap-1">
          {settingsTabs.map((tab) => {
            const allowed = permissions[tab.permission];
            return (
              <button
                key={tab.id}
                type="button"
                className={`flex items-center gap-2 px-4 py-3 rounded-t-xl text-sm font-medium transition-colors ${
                  !allowed ? 'opacity-50 cursor-not-allowed' : ''
                } ${
                  activeTab === tab.id
                    ? 'bg-white text-[#4F6BFF] border border-gray-200 border-b-white -mb-px shadow-sm'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-white/50'
                }`}
                onClick={() => handleTabChange(tab.id)}
                disabled={!allowed}
                title={!allowed ? `You don't have permission to view ${tab.label.toLowerCase()}` : ''}
              >
                <Icon icon={tab.icon} width="20" height="20" />
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="p-4 sm:p-5 lg:p-6">
          {activeTab === "about-organization" && <AboutOrganization />}
          {activeTab === "faq" && <FAQ />}
          {activeTab === "query" && <Query />}
          {/* Payment history temporarily hidden */}
          {/* {activeTab === "payment-history" && <PaymentHistory />} */}
        </div>
      </div>
    </AdminPage>
  );
}

export default Settings;
